// import React, { useEffect, useState } from "react";

// // region import from local file
// // import closeIcon from '../../../assets/images/Sidebar/close-menu.png';
// import closeIcon from '../../../assets/images/Sidebar/collapseImg.svg';
// // import openIcon from '../../../assets/images/Sidebar/open-menu.png';
// import openIcon from '../../../assets/images/Sidebar/openImg.svg';
// import companyLogo from '../../../assets/images/Sidebar/company-logo.svg';
// import companySmallLogo from '../../../assets/images/Sidebar/company-small-logo.svg';
// import dashboard from '../../../assets/images/Sidebar/dashboard.svg';
// import chevronUpImg from '../../../assets/images/Dashboard/chevron-down.svg';
// import customerManagement from '../../../assets/images/Sidebar/customer-management.svg';
// import userManagement from '../../../assets/images/Sidebar/user-management.svg';
// import attendanceLeaves from '../../../assets/images/Sidebar/attendance-leaves.svg';
// import complaintEscalation from '../../../assets/images/Sidebar/complaint-escalation.svg';
// import serviceLevelAgreement from '../../../assets/images/Sidebar/service-level-agreement.svg';
// import workQueues from '../../../assets/images/Sidebar/work-queues.svg';
// import systemLogging from '../../../assets/images/Sidebar/system-logging.svg';
// import { useLocation, useNavigate } from "react-router-dom";
// // endregion

// export default function SideBar({ setClick, click }) {
//     const handleClick = () => setClick(!click);

//     const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
//     const AssignedModules = JSON.parse(sessionStorage.getItem('AssignedModules'));
//     console.log(AssignedModules,'AssignedModules')
//     const [systemLoggingOpen, setSystemLoggingOpen] = useState(false);
//     const [activeMenu, setActiveMenu] = useState('/dashboard');

//     const navigate = useNavigate()
//     const location = useLocation(); // Use useLocation to track route changes

//     useEffect(() => {
//         // Update activeMenu based on current route
//         setActiveMenu(location.pathname);
//     }, [location.pathname]);

//     const handleNavigation = (path) => {
//         setActiveMenu(path);
//         navigate(path);
//     }

//     return (
//         <div className="lm-sidevar">
//             <div className={`container ${click ? "clicked" : ""}`} style={{ width: click ? "18.5vw" : "6vw" }}>
//                 <button className={`button ${click ? "clicked" : ""}`} onClick={handleClick}>
//                     <img src={click ? closeIcon : openIcon} alt="open-close" />
//                 </button>
//                 <div className="sidebar-container">
//                     {/* <div style={{ width: "100%" }}>
//                         <img
//                             src={click ? companyLogo : companySmallLogo}
//                             alt="Company Logo"
//                             className={click ? 'company-logo' : 'company-small-logo'}
//                         />
//                     </div> */}
//                     <div style={{ width: "100%" }}>
//                         <img
//                             src={companyLogo}
//                             alt="Company Logo"
//                             className={`company-logo ${click ? "clicked" : ""}`}
//                         />
//                         <img
//                             src={companySmallLogo}
//                             alt="Company Small Logo"
//                             className={`company-small-logo ${click ? "clicked" : ""}`}
//                         />
//                     </div>

//                     <ul className={`slick-bar ${click ? "clicked" : ""}`}>
//                         <li
//                             // className="item pt-4" 
//                             className={`item pt-4 ${activeMenu === "/dashboard" ? "clicked" : ""}`}
//                             onClick={() => handleNavigation("/dashboard")}>
//                             <img src={dashboard} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Dashboard</span>
//                         </li>
//                         {signInDetails[0].SignInType !== "ClientAdmin" && signInDetails[0].SignInType !== "User" && <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/customermanagement" ? "clicked" : ""}`}
//                             onClick={() => handleNavigation("/customermanagement")}>
//                             <img src={customerManagement} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Customer Management</span>
//                         </li>}
//                         {signInDetails[0].SignInType !== "User" && <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/usermanagement" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/usermanagement") }}>
//                             <img src={userManagement} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>User Management</span>
//                         </li>}
//                         <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/leaves" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/leaves") }}>
//                             <img src={attendanceLeaves} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Leave & Holiday</span>
//                         </li>
//                         <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/complaint" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/complaint") }}>
//                             <img src={complaintEscalation} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Complaint / Escalation</span>
//                         </li>
//                         <li
//                             // className="item"
//                             className={`item ${activeMenu === "/sla" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/sla") }}>
//                             <img src={serviceLevelAgreement} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Service Level Agreement</span>
//                         </li>
//                         <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/workqueues" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/workqueues") }}>
//                             <img src={workQueues} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Work Queues</span>
//                         </li>
//                         <li
//                             // className="item"
//                             // className={`item ${systemLoggingOpen ? "open" : ""}`} onClick={() => setSystemLoggingOpen(!systemLoggingOpen)}
//                             className={`item ${systemLoggingOpen ? "open" : ""} ${activeMenu === "/systemlogging" ? "clicked" : ""}`}
//                             onClick={() => setSystemLoggingOpen(!systemLoggingOpen)}
//                         >
//                             <img src={systemLogging} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>System Logging</span>
//                             <img src={chevronUpImg} alt="" className={systemLoggingOpen ? "sidebar-chevron-down" : "sidebar-chevron-right"} />
//                         </li>
//                         {systemLoggingOpen && (
//                             <ul className="sub-menu">
//                                 <li
//                                     // className="sub-item pt-2 pb-2"
//                                     className={`sub-item pt-2 pb-2 ${activeMenu === "/audit-trial" ? "clicked" : ""}`}
//                                     onClick={() => handleNavigation("/audit-trial")}>
//                                     <img src={serviceLevelAgreement} alt="" />
//                                     <span className={`text ${click ? "clicked" : ""}`}>Audit Trial</span>
//                                 </li>
//                                 <li
//                                     //  className="sub-item pt-2 pb-2" 
//                                     className={`sub-item pt-2 pb-2 ${activeMenu === "/exception-log" ? "clicked" : ""}`}
//                                     onClick={() => handleNavigation("/exception-log")}>
//                                     <img src={serviceLevelAgreement} alt="" />
//                                     <span className={`text ${click ? "clicked" : ""}`}>Exception Log</span>
//                                 </li>
//                                 <li
//                                     // className="sub-item pt-2 pb-2"
//                                     className={`sub-item pt-2 pb-2 ${activeMenu === "/integration-log" ? "clicked" : ""}`}
//                                     onClick={() => handleNavigation("/integration-log")}>
//                                     <img src={serviceLevelAgreement} alt="" />
//                                     <span className={`text ${click ? "clicked" : ""}`}>Integration Log</span>
//                                 </li>
//                             </ul>
//                         )}
//                     </ul>
//                 </div>
//             </div>
//         </div>
//     );
// }



// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// // Import icons and assets
// import closeIcon from "../../../assets/images/Sidebar/collapseImg.svg";
// import openIcon from "../../../assets/images/Sidebar/openImg.svg";
// import companyLogo from "../../../assets/images/Sidebar/company-logo.svg";
// import companySmallLogo from "../../../assets/images/Sidebar/company-small-logo.svg";
// import chevronUpImg from "../../../assets/images/Dashboard/chevron-down.svg";
// import { useDispatch, useSelector } from "react-redux";
// import { loadRoleBasedModulePermissionsData } from "../../../redux/action";

// export default function SideBar({ setClick, click }) {
//     const [activeMenu, setActiveMenu] = useState("/dashboard");
//     const [openSubMenus, setOpenSubMenus] = useState({}); // Track open submenus

//     const navigate = useNavigate();
//     const location = useLocation();
//     let dispatch = useDispatch();
//     const { modulePermissions } = useSelector((state) => state.data);

//     useEffect(() => {
//         dispatch(loadRoleBasedModulePermissionsData());
//     }, []);

//     const handleNavigation = (path) => {
//         setActiveMenu(path);
//         navigate(path);
//     };

//     const handleClick = () => setClick(!click);

//     const handleSubMenuToggle = (moduleId) => {
//         setOpenSubMenus((prev) => ({
//             ...prev,
//             [moduleId]: !prev[moduleId], // Toggle submenu for specific module
//         }));
//     };

//     useEffect(() => {
//         // Update activeMenu when the location changes
//         setActiveMenu(location.pathname);
//     }, [location.pathname]);

//     return (
//         <div className="lm-sidevar">
//             <div className={`container ${click ? "clicked" : ""}`} style={{ width: click ? "18.5vw" : "6vw" }}>
//                 <button className={`button ${click ? "clicked" : ""}`} onClick={handleClick}>
//                     <img src={click ? closeIcon : openIcon} alt="toggle-menu" />
//                 </button>
//                 <div className="sidebar-container">
//                     <div style={{ width: "100%" }}>
//                         <img
//                             src={companyLogo}
//                             alt="Company Logo"
//                             className={`company-logo ${click ? "clicked" : ""}`}
//                         />
//                         <img
//                             src={companySmallLogo}
//                             alt="Company Small Logo"
//                             className={`company-small-logo ${click ? "clicked" : ""}`}
//                         />
//                     </div>
//                     <ul className={`slick-bar ${click ? "clicked" : ""}`}>
//                         {modulePermissions.map((module) => (
//                             <React.Fragment key={module.Modules_IDPK}>
//                                 <li
//                                     className={`item ${activeMenu === module.ModuleNavigationUrl ? "clicked" : ""}`}
//                                     onClick={() => {
//                                         if (module.ModuleNavigationUrl) {
//                                             handleNavigation(module.ModuleNavigationUrl); // Navigate if URL exists
//                                         } else if (module.SubModules && module.SubModules.length) {
//                                             handleSubMenuToggle(module.Modules_IDPK); // Toggle submenu
//                                         }
//                                     }}
//                                 >
//                                     <img src={module.ModuleIconPath} alt={module.Modules_Name} />
//                                     <span className={`text ${click ? "clicked" : ""}`}>{module.Modules_Name}</span>
//                                     {module.SubModules && module.SubModules.length > 0 && (
//                                         <img
//                                             src={chevronUpImg}
//                                             alt="toggle-submenu"
//                                             className={openSubMenus[module.Modules_IDPK] ? "sidebar-chevron-down" : "sidebar-chevron-right"}
//                                             onClick={(e) => {
//                                                 e.stopPropagation(); // Prevent event bubbling to parent `li`
//                                                 handleSubMenuToggle(module.Modules_IDPK);
//                                             }}
//                                         />
//                                     )}
//                                 </li>
//                                 {module.SubModules && openSubMenus[module.Modules_IDPK] && (
//                                     <ul className="sub-menu">
//                                         {module.SubModules.map((subModule) => (
//                                             <li
//                                                 key={subModule.SubModuleID}
//                                                 className={`sub-item pt-2 pb-2 ${activeMenu === subModule.SubModuleNavigationUrl ? "clicked" : ""}`}
//                                                 onClick={(e) => {
//                                                     e.stopPropagation(); // Prevent bubbling
//                                                     handleNavigation(subModule.SubModuleNavigationUrl);
//                                                 }}
//                                             >
//                                                 <img src={subModule.SubModuleIconPath || module.ModuleIconPath} alt={subModule.SubModuleName} />
//                                                 <span className={`text ${click ? "clicked" : ""}`}>{subModule.SubModuleName}</span>
//                                             </li>
//                                         ))}
//                                     </ul>
//                                 )}
//                             </React.Fragment>
//                         ))}
//                     </ul>
//                 </div>
//             </div>
//         </div>
//     );
// }





import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Import icons and assets
import closeIcon from "../../../assets/images/Sidebar/collapseImg.svg";
import openIcon from "../../../assets/images/Sidebar/openImg.svg";
import companyLogo from "../../../assets/images/Sidebar/company-logo.svg";
import companySmallLogo from "../../../assets/images/Sidebar/company-small-logo.svg";
import chevronUpImg from "../../../assets/images/Dashboard/chevron-down.svg";
import { useDispatch, useSelector } from "react-redux";
import { loadRoleBasedModulePermissionsData } from "../../../redux/action";

export default function SideBar({ setClick, click }) {
    const [activeMenu, setActiveMenu] = useState("/dashboard");
    const [openSubMenus, setOpenSubMenus] = useState({}); // Track open submenus

    const navigate = useNavigate();
    const location = useLocation();
    let dispatch = useDispatch();
    const { modulePermissions = []} = useSelector((state) => state.data);

    // const [modulePermissions, setModulePermissions] = useState([]);

    useEffect(() => {
        dispatch(loadRoleBasedModulePermissionsData());
    }, []);

    // Check sessionStorage for module permissions data
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    // useEffect(() => {
    //     // Only set the state if the sessionStorage data is not empty and it's not already loaded in state
    //     if (storedModulePermissions.length > 0 && modulePermissions.length === 0) {
    //         setModulePermissions(storedModulePermissions); // Set module permissions only if not already set
    //     } else if (storedModulePermissions.length === 0) {
    //         // If sessionStorage is empty, dispatch action to fetch permissions
    //         dispatch(loadRoleBasedModulePermissionsData());
    //     }
    // }, [storedModulePermissions, dispatch, modulePermissions]);

    const handleNavigation = (path, moduleId = null) => {
        if (moduleId) {
            navigate(path, { state: { moduleId } });
        } else {
            navigate(path);
        }
        setActiveMenu(path);
    };

    const handleClick = () => setClick(!click);

    const handleSubMenuToggle = (moduleId) => {
        setOpenSubMenus((prev) => ({
            ...prev,
            [moduleId]: !prev[moduleId], // Toggle submenu for specific module
        }));
    };

    useEffect(() => {
        // Update activeMenu when the location changes
        setActiveMenu(location.pathname);
    }, [location.pathname]);

    return (
        <div className="lm-sidevar">
            <div className={`container ${click ? "clicked" : ""}`} style={{ width: click ? "18.5vw" : "6vw" }}>
                <button className={`button ${click ? "clicked" : ""}`} onClick={handleClick}>
                    <img src={click ? closeIcon : openIcon} alt="toggle-menu" />
                </button>
                <div className="sidebar-container">
                    <div style={{ width: "100%" }}>
                        <img
                            src={companyLogo}
                            alt="Company Logo"
                            className={`company-logo ${click ? "clicked" : ""}`}
                        />
                        <img
                            src={companySmallLogo}
                            alt="Company Small Logo"
                            className={`company-small-logo ${click ? "clicked" : ""}`}
                        />
                    </div>
                    <ul className={`slick-bar ${click ? "clicked" : ""}`}>
                        {modulePermissions?.map((module) => (
                            <React.Fragment key={module.Modules_IDPK}>
                                <li
                                    className={`item ${activeMenu === module.ModuleNavigationUrl ? "clicked" : ""}`}
                                    onClick={() => {
                                        if (module.ModuleNavigationUrl) {
                                            handleNavigation(module.ModuleNavigationUrl, module.Modules_IDPK); // Navigate with module ID
                                        } else if (module.SubModules && module.SubModules.length) {
                                            handleSubMenuToggle(module.Modules_IDPK); // Toggle submenu
                                        }
                                    }}
                                >
                                    <img src={module.ModuleIconPath} alt={module.Modules_Name} />
                                    <span className={`text ${click ? "clicked" : ""}`}>{module.Modules_Name}</span>
                                    {module.SubModules && module.SubModules.length > 0 && (
                                        <img
                                            src={chevronUpImg}
                                            alt="toggle-submenu"
                                            className={openSubMenus[module.Modules_IDPK] ? "sidebar-chevron-down" : "sidebar-chevron-right"}
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent event bubbling to parent `li`
                                                handleSubMenuToggle(module.Modules_IDPK);
                                            }}
                                        />
                                    )}
                                </li>
                                {module.SubModules && openSubMenus[module.Modules_IDPK] && (
                                    <ul className="sub-menu">
                                        {module.SubModules.map((subModule) => (
                                            <li
                                                key={subModule.SubModuleID}
                                                className={`sub-item pt-2 pb-2 ${activeMenu === subModule.SubModuleNavigationUrl ? "clicked" : ""}`}
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent bubbling
                                                    handleNavigation(subModule.SubModuleNavigationUrl, subModule.SubModuleID); // Send SubModule ID
                                                }}
                                            >
                                                <img src={subModule.SubModuleIconPath || module.ModuleIconPath} alt={subModule.SubModuleName} />
                                                <span className={`text ${click ? "clicked" : ""}`}>{subModule.SubModuleName}</span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}

